import { useContext } from "react";
import { ToastContext, Toast, ToastType } from "../context/ToastContext";
import { FaCheck, FaTimes, FaExclamationTriangle, FaInfoCircle } from "react-icons/fa"
import "./Toast.css";

/* ─── Icons ──────────────────────────────────────────────── */
const ICONS: Record<ToastType, JSX.Element> = {
  success: <FaCheck />,
  error:   <FaTimes />,
  warning: <FaExclamationTriangle />,
  info:    <FaInfoCircle />,
};


/* ─── Single Toast Item ──────────────────────────────────── */
function ToastItem({ toast }: { toast: Toast }) {
  return (
    <div className={`toast-item toast-${toast.type}`}>
      <div className="toast-icon">{ICONS[toast.type]}</div>
      <span className="toast-message">{toast.message}</span>
      <div className="toast-progress" />
    </div>
  );
}

/* ─── Toast Container ────────────────────────────────────── */
export default function ToastContainer() {
  const ctx = useContext(ToastContext);
  if (!ctx || ctx.toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {ctx.toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} />
      ))}
    </div>
  );
}